import UiForm from "./UiForm";
import { EnumMiezzFormItemType, MiezzFormItem } from "@/models/MiezzForm";
import DtoPutOrderPoolContainerTrailer_ExecutorItem from "./DtoPutOrderPoolContainerTrailer_ExecutorItem";
import UiGroup from "./UiGroup";

/**
 * 
 * @description 自动生成的代码,请勿修改
 */
export default class DtoPutOrderPoolContainerTrailer_Executor extends UiForm<string> {
    constructor() {
        //无参构造函数
        super()
        this.Executors = [];
        this.UiGroups = [];
    }

    [proName: string]: any;
    /**
     * 
     */
    Executors?: DtoPutOrderPoolContainerTrailer_ExecutorItem[];
}

/**
 * -表单校验
 */
export const DtoPutOrderPoolContainerTrailer_ExecutorRules = {
}

/**
 * -设置项
 */
export const DtoPutOrderPoolContainerTrailer_ExecutorMiezzFormItems: MiezzFormItem[] = [
  {
    Prop: "Executors",
    Label: "",
    Customize: true,
  },
]
